export enum AlertType {
  None = '',
  Success = 'Success',
  Error = 'Error',
  Info = 'Info',
  Warning = 'Warning'
}
